import { userProfileObtained } from '@/configuration/login/loginSlice';

import { startAppListening } from '../middleware/listenerMiddleware';
import { resetActiveThread } from './threadSlice';

export const FLEET_ACCOUNT_STORAGE_KEY = 'fleetAccount';

// INFO: Since threads are fleet specific, the active thread must be reset once the fleet changes
startAppListening({
  actionCreator: userProfileObtained,
  effect: ({ payload }, { dispatch }) => {
    const account = payload.account ?? '';
    const previousAccount = sessionStorage.getItem(FLEET_ACCOUNT_STORAGE_KEY);
    sessionStorage.setItem(FLEET_ACCOUNT_STORAGE_KEY, account);

    if (previousAccount !== null && previousAccount !== account) dispatch(resetActiveThread());
  },
});
